import { type OrganizationManagerNotification } from "@entities";
import { useQuery } from "@tanstack/react-query";
import React, { createContext, useCallback, useContext, type FC } from "react";
import { useUser } from "./UserProvider";

export const NotificationContext = createContext<{
  notifications: OrganizationManagerNotification[];
  markAllAsRead: VoidFunction;
  unreadCount: number;
} | null>(null);

export const useNotifications = () => useContext(NotificationContext)!;

interface Props {
  children?: React.ReactNode;
}

export const NotificationProvider: FC<Props> = ({ children }) => {
  const { currentUser } = useUser();

  const { data: notifications, refetch } = useQuery({
    queryKey: ['notifications', currentUser?.id],
    queryFn: async () => {
      if (!currentUser?.id) return [];
      return []
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled: Boolean(currentUser?.id),
    staleTime: 60 * 1000, // 2 minutes in milliseconds
  });

  const markAllAsRead = async () => {
    // Await organizationManagerNotificationRepo.updateMany({
    //   where: {
    //     $and: [
    //       {
    //         toId: currentUser?.id,
    //         hasRead: false,
    //       },
    //     ],
    //   },
    //   set: {
    //     hasRead: true,
    //   },
    // });
    refetch();
  };

  return (
    <NotificationContext.Provider
      value={{
        notifications: notifications ?? [],
        markAllAsRead,
        unreadCount: (notifications ?? []).filter((v: OrganizationManagerNotification) => !v.hasRead).length,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
